import { render, staticRenderFns } from "./MultiselectElement.vue?vue&type=template&id=6d168785&scoped=true&"
import script from "./MultiselectElement.vue?vue&type=script&lang=js&"
export * from "./MultiselectElement.vue?vue&type=script&lang=js&"
import style0 from "../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MultiselectElement.vue?vue&type=style&index=1&id=6d168785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d168785",
  null
  
)

export default component.exports